/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./discovery-tool-integration.vue?vue&type=template&id=f7e56252&"
import script from "./discovery-tool-integration.vue?vue&type=script&lang=ts&"
export * from "./discovery-tool-integration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports